<template>
    <div class="member-order-list">
        <div class="common-header-wrap">
            <mt-header :title="$t('BlindBox')" class="common-header">
                <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
            </mt-header>
        </div>
        <!-- <div class="common-header-wrap">
            <div class="common-header">
                <mt-button class="back" slot="left" icon="back" @click="$router.go(-1)"></mt-button>
                <div class="common-search">
                    <input type="text" v-model="keyword" :placeholder="$t('orderSearch')" readonly>
                </div>
            </div>
        </div> -->
        <!-- header -->

        <div class="search">
            <div class="l">
                <div class="icon">
                    <img src="../../../assets/image/home/Search.png" alt="">
                </div>
                <input type="text" v-model="order_sn" :placeholder="$t('orderSearch')" @keyup.enter="handleEnter" />
            </div>
            <div class="search1 button" @click="handleEnter">{{ $t('Search') }}</div>
        </div>

        <div class="order-header">
            <ul ref="tagBar">
                <li class="item tag" v-for="(item, index) in orderNav" v-bind:key="item.id"
                    v-bind:class="{ active: stateType == item.id }" v-on:click="setOrderNavActive(item.id, index)">
                    {{ item.name }}
                </li>
            </ul>
        </div>

        <div v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="10">
            <div class="order-body" v-if="order_group_list && order_group_list.length">

                <div class="list" v-for="item in order_group_list" :key="item.id">
                    <router-link :to="'/member/blind_detail?order_id=' + item.id">
                        <div class="tips-body">
                            <span class="tips">{{ $t('Order Date') }}: {{ item.create_time_text }}</span>
                            <span class="title tips statusTips">
                                {{
                                    item.status == 4 ? $t('Pending Draw') :
                                    item.status == 0 ? $t('Pending Unboxing') :
                                        item.status == 1 ? $t('Unboxed') :
                                            item.status == 2 ? $t('Collected') :
                                                item.status == 3 ? $t('Recycled') : $t('Unknown')
                                }}
                            </span>
                        </div>

                        <div class="order-image">
                            <div class="goods_info clearfix">
                                <div class="img">
                                    <img v-bind:src="item.img" />
                                </div>
                                <div class="goods_name">{{ item.title }}</div>
                            </div>
                        </div>
                        <div class="order-image" v-if="item.box_goods">
                            <div class="goods_info clearfix" style="padding-left:0.6rem;">
                                <div class="img">
                                    <img v-bind:src="item.box_goods.goods_image" />
                                </div>
                                <div class="goods_name">{{ item.box_goods.goods_name }}</div>
                                <div class="goods_price">
                                    <div class="price">${{ item.box_goods.goods_price }}</div>
                                    <div class="num">X{{ 1 }}</div>
                                </div>
                            </div>
                        </div>

                        <div class="order_amount">
                            {{ $t('cart.total') }}:
                            <i class="order_amount_icon">$</i>
                            <i class="i">{{ item.total }}</i>
                        </div>
                    </router-link>

                    <div class="order-list-opratio">
                        <router-link :to="'/member/pick_up_goods?order_id=' + item.id">
                            <button class="button" v-if="item.status == 1">{{ $t('Claim') }}</button>
                        </router-link>
                        <!-- Refund or Cancel Order -->
                        <button v-if="item.status == 1" v-on:click="cancel(item)" class="line_red button">
                            {{ $t('Recycle') }}
                        </button>
                        <button class="button" v-if="item.status == 0" @click="open(item)">{{ $t('Unbox') }}</button>
                    </div>
                </div>
            </div>
            <empty-record v-else-if="order_group_list && !order_group_list.length"></empty-record>
        </div>

        <!-- <mt-popup v-model="popupVisible">
          <div class="popup-box">
            <img class="popup-img" src="../../../assets/image/member/open.gif" />
          </div>
        </mt-popup> -->
    </div>
</template>

<script>
import { getOrderList, getBoxList, openBox, cancelOrder, addBoxSave, receiveOrder, deleteOrder } from '../../../api/memberOrder'
import { Toast, MessageBox, Indicator } from 'mint-ui'
import { mapState } from 'vuex'
import EmptyRecord from '../../../components/EmptyRecord'
export default {
    components: {
        EmptyRecord
    },
    name: 'MemberOrderList',
    data() {
        return {
            order_id: 0,
            status: null,
            keyword: this.$route.query.keyword ? this.$route.query.keyword : '', // 关键字
            order_sn: '', // 关键字
            orderNav: [
                {
                    'name': this.$t('All'),
                    'id': null
                },
                {
                    'name': this.$t('Pending Draw'),
                    'id': '4'
                },
                // {
                //     'name': this.$t('Pending Unboxing'),
                //     'id': '0'
                // },
                {
                    'name': this.$t('Unboxed'),
                    'id': '1'
                },
                {
                    'name': this.$t('Collected'),
                    'id': '2'
                },
                {
                    'name': this.$t('Recycled'),
                    'id': '3'
                }
            ],
            stateType: this.$route.query.state ? this.$route.query.state : null,
            orderDetailVisible: false,
            wrapperHeight: 0,
            params: { 'page': 0, 'per_page': 10 },
            loading: false, // 是否加载更多
            isMore: true, // 是否有更多
            order_group_list: false,
            popupVisible: false,
        }
    },

    mounted() {
        window.scrollTo(0, 0);
        this.wrapperHeight = document.documentElement.clientHeight - 140
    },
    computed: {
        ...mapState({
            user: state => state.member.info
        })
    },
    created: function () {
        // this.getOrderList(true)
    },

    methods: {
        open(orderInfo) {
            this.popupVisible = true;

            openBox(orderInfo.id).then(res => {

                Toast(res.message)
                setTimeout(() => {
                    this.popupVisible = false;
                    this.$router.push({ name: 'BlindBoxDetail', query: { order_id: res.result.id } })
                }, 1000);

            }).catch(function (error) {
                Toast(error.message)
                this.popupVisible = false;
            })
        },
        goOrderSearch() {
            this.$router.push({ name: 'MemberOrderSearch' })
        },
        setOrderNavActive(index, ind) {
            this.stateType = index
            this.getOrderList(true)
            this.centerTag(ind);
        },
        centerTag(index) {
            const tagElements = this.$refs.tagBar.getElementsByClassName('tag');
            if (tagElements.length > 0) {
                const selectedTag = tagElements[index];
                const tagBar = this.$refs.tagBar;

                if (!selectedTag) return
                // 计算需要滚动的距离
                const scrollTo = selectedTag.offsetLeft + (selectedTag.offsetWidth / 2) - (tagBar.offsetWidth / 2);

                // 设置平滑滚动
                tagBar.scrollTo({
                    left: scrollTo,
                    behavior: 'smooth'
                });
            }
        },
        showMessage(message, title) {
            MessageBox.alert(message, title)
        },
        cancel(orderInfo) {
            let that = this
            MessageBox({
                title: that.$t('MessageBox.Tips'),
                message: that.$t('MessageBox.recycle.box'),
                confirmButtonText: that.$t('MessageBox.Confirm'),
                cancelButtonText: that.$t('MessageBox.Cancel'),
                showCancelButton: true
            }).then(action => {
                if (action == 'confirm') {
                    addBoxSave(orderInfo.id).then(res => {
                        Toast(res.message);
                        // this.getOrderList(true);
                        that.setOrderNavActive(3);
                    }).catch(function (error) {
                        Toast(error.message);
                    });
                }
            });
        },
        deliver(orderId) {
            this.$router.push({ name: 'MemberOrderDeliver', query: { order_id: orderId } })
        },
        goRefund(refundId) {
            this.$router.push({ name: 'MemberRefundView', query: { refund_id: refundId } })
        },
        refund(orderId) {
            this.$router.push({ name: 'MemberRefundForm', query: { order_id: orderId } })
        },
        evaluate(orderId) {
            this.$router.push({ name: 'MemberOrderEvaluate', params: { order_id: orderId } })
        },
        pay(paySn) {
            this.$router.push({ name: 'MemberBuyPay', query: { pay_sn: paySn, pay_type: 'pay_new' } })
        },
        getOrderInfo(orderId) {
            this.orderDetailVisible = true
            this.order_id = orderId
        },
        loadMore() {
            this.loading = true
            this.params.page = ++this.params.page
            console.log(this.isMore);
            if (this.isMore) {
                this.loading = false
                this.getOrderList(false)
            }
        },
        handleEnter() {
            // if (!this.keyword) return
            this.getOrderList(true)
        },
        getOrderList(ifReplace) {
            Indicator.open()
            if (ifReplace) {
                this.loading = false
                this.params.page = 1
                this.isMore = true
            }

            getBoxList(this.params, this.stateType, '', this.keyword, this.stateType, this.order_sn).then(res => {
                Indicator.close()
                if (res.result.current_page !== res.result.last_page) {
                    this.isMore = true
                } else {
                    this.isMore = false
                }

                // let tOrderGroup = res.result.order_group_list
                let tOrderGroup = res.result.data

                if (tOrderGroup) {
                    if (ifReplace || !this.order_group_list) {
                        this.order_group_list = tOrderGroup
                    } else {
                        this.order_group_list = this.order_group_list.concat(tOrderGroup)
                    }
                }
            }).catch(function (error) {
                Indicator.close()
                Toast(error.message)
            })
        }
    }
}
</script>

<style  lang="scss" scoped>
.search {
    width: 360px;
	margin: 20px auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #F9F9F9;
    border-radius: 50px 50px 50px 50px;
    padding: .4rem 1rem;

    .l {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .icon {
            width: .7rem;
            height: .7rem;
            margin-right: .3rem;

            img {
                width: 100%;
                height: 100%;
                display: block;
            }
        }
    }

    .search1 {
        // background: #fa2a31;
        border-radius: 10px;
        color: #E7010C;
        // padding: 0 10px;
        font-size: .6rem;
        height: 1.6rem;
        line-height: 1.6rem;
        margin-left: 10px;
    }

    input {
        box-sizing: border-box;
        width: 100%;
        height: 1.6rem;
        border-radius: 10px;
        background-size: 0.55rem;
        font-size: 0.6rem;
        color: #000000;
        background: #F9F9F9;
        // padding-left: 1.6rem;
        border: 0;
    }
}

.member-order-list {
    
    background: #fff;

    .back {
        background-color: #fff;
        box-shadow: none;
    }

    .common-header {
        display: flex;
        align-items: center;
        line-height: normal;
        // padding: .1rem 0;
        box-shadow: none;
    }

    .common-search {
        padding: 0;
        padding-left: $pageSpace;
        padding-right: $pageSpace;
        flex: 1;

        input {
            box-sizing: border-box;
            width: 100%;
            height: 1.6rem;
            border-radius: 1.6rem;
            background: #F4F4F4 url(../../../assets/image/home/icon_search.png) no-repeat 0.6rem center;
            background-size: 0.55rem;
            font-size: $fontSize;
            color: #999;
            padding-left: 1.6rem;
            border: 0;
        }
    }

    .order-header {
        width: 435px !important;
  	    margin: auto;
        height: 2rem;
        width: 100%;
        top: 2rem;
        z-index: 100;
        box-sizing: border-box;
        padding: 0 .4rem;
        overflow: hidden;
        background: rgba(255, 255, 255, 1);

        ul {
            scroll-snap-type: x mandatory;
            -webkit-overflow-scrolling: touch;
            /* iOS 平滑滚动 */
            list-style: none;
            width: auto;
            width: 100%;
            overflow: hidden;
            overflow-x: auto;
            white-space: nowrap;
            height: 100%;
            border-bottom: 1px solid #e8eaed;
            -ms-overflow-style: none;
            /* IE and Edge */
            scrollbar-width: none;
            /* Firefox */

            &::-webkit-scrollbar {
                display: none;
            }

            li {
                box-sizing: border-box;
                margin: 0 .2rem;
                padding: .5rem .6rem;
                border-radius: 10px 10px 10px 10px;
                display: inline-block;
                font-size: $subFontSize;
                color: #333;
                height: 100%;
                text-align: center;
                line-height: 1rem;
                border-bottom: 0.1rem solid transparent;
                white-space: nowrap;

                &.active {
                    // color: $primaryColor;
                    // border-bottom-color: $primaryColor;
                    color: #fff;
                    padding: .5rem .8rem;
                    background: #E7010C;
                }
            }
        }
    }

    .order-body {
        position: relative;
        padding-top: 2.3rem;

        .list {
            width: 100%;
            margin-top: 0.5rem;

            .order-image {
                height: 4.55rem;
                background: rgba(250, 250, 250, 1);
                width: 100%;
                overflow: hidden;
                overflow-x: auto;
                white-space: nowrap;

                .goods_info {
                    height: 4rem;
                    margin-bottom: .5rem;
                    display: flex;
                    align-items: center;
                    padding-right: $pageSpace;

                    .img {
                        width: 3rem;
                        height: 3rem;
                        margin: .85rem .3rem .5rem;

                        img {
                            width: 3rem;
                            height: 3rem;
                            border-radius: 1px;
                        }
                    }

                    .goods_name {
                        white-space: normal;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        -webkit-box-orient: vertical;
                        max-width: 35rem;
                        font-size: .7rem;
                        color: #333;
                    }

                    .goods_price {
                        margin-left: auto;
                        padding-right: .75rem;
                        text-align: right;

                        .price {
                            font-size: $subFontSize;
                            color: rgba(78, 84, 93, 1);
                        }

                        .num {
                            font-size: .6rem;
                            color: #999;
                            padding-top: .3rem;
                        }
                    }
                }
            }

            .multiple {
                .imagebox {
                    width: 100%;
                    overflow-x: auto;
                    white-space: nowrap;

                    img {
                        width: 3rem;
                        height: 3rem;
                        margin: .85rem .3rem .5rem;
                        display: inline-block;
                    }
                }
            }
        }

        .loading-wrapper {
            text-align: center;

            p {
                color: #c3c3c3;
                font-size: $fontSize;
                margin: 0.5rem auto;
            }
        }
    }

    .order-body {
        position: relative;
        padding: .4rem .5rem;

        .list {
            width: 100%;
            padding: .7rem .6rem;
            box-sizing: border-box;
            margin-bottom: 1rem;
            background: #fafafa;
            border-radius: 10px 10px 10px 10px;

            .tips-body {
                // height: 2.2rem;
                // background: rgba(255, 255, 255, 1);
                // box-shadow: 0 0.5px 0 0 rgba(232, 234, 237, 1);
                display: flex;
                justify-content: space-between;
                padding: 0 0 .6rem;
                border-bottom: 1px solid #DEDEDE;

                .tips {
                    font-size: .6rem;
                    color: #7d7d7d;
                    // line-height: 2.2rem;
                }

                .statusTips {
                    color: $primaryColor;
                }

                .copy {
                    font-weight: 600;
                    margin: 0 0;
                    font-size: .6rem;
                }

                img {
                    width: 3.8rem;
                    height: 3rem;
                }
            }

            .order-image {
                // height: 4.55rem;
                // background: rgba(250, 250, 250, 1);
                width: 100%;
                overflow: hidden;
                overflow-x: auto;
                white-space: nowrap;
            }

            .multiple {
                .imagebox {
                    width: 100%;
                    overflow-x: auto;
                    white-space: nowrap;

                    img {
                        width: 3rem;
                        height: 3rem;
                        margin: .85rem .3rem .5rem;
                        display: inline-block;
                    }
                }
            }

            .number-code {
                font-size: $subFontSize;
                color: rgba(78, 84, 93, 1);
                background-color: #fff;

                .nci {
                    height: 2rem;
                    padding: 0 .75rem;
                    border-bottom: 1px solid #e8eaed;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;

                    .tit {
                        margin-bottom: .1rem;
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                    }

                    .cc {
                        padding: 0 .1rem;
                    }

                    .copy {
                        color: $primaryColor;
                        font-weight: 600;
                    }
                }
            }

            .order_amount {
                font-size: $subFontSize;
                color: rgba(78, 84, 93, 1);
                // line-height: 2.2rem;
                // height: 2.2rem;
                // background-color: #fff;
                padding: 0 0.5rem;
                // border-bottom: 1px solid #e8eaed;
                box-sizing: border-box;
                text-align: right;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                display: flex;
                justify-content: flex-end;
                align-items: center;
                color: $primaryColor;
                font-weight: 600;

                .order_amount_icon {
                    font-size: $subFontSize;
                    color: $primaryColor;
                }

                i {
                    font-size: $h2;
                    color: $primaryColor;
                    padding-left: 0.15rem;
                    font-style: normal;

                    &.freight {
                        color: #333;
                        font-size: $fontSize;
                    }
                }
            }
        }

        .loading-wrapper {
            text-align: center;

            p {
                color: #c3c3c3;
                font-size: $fontSize;
                margin: 0.5rem auto;
            }
        }
    }

    .mint-popup {
        width: 100%;
        height: 11.75rem;
    }
}

.order-list-opratio {
    height: 2.2rem;
    display: flex;
    justify-content: flex-end;
    // background: rgba(255, 255, 255, 1);
    border-radius: 0.1rem;
}

.order-list-opratio button {
    width: 4.5rem;
    height: 1.5rem;
    font-size: $subFontSize;
    border-radius: 0.7rem;
    margin: 0.35rem 0.75rem 0.35rem 0;
    background: #fff;
    border: 1px solid #ccc;
    box-shadow: 0 3px 6px 0 rgba(0, 0, 0, .05);
}

.order-list-opratio .line_red {
    background: #fff;
    color: #f2270c;
    border: 1px solid #f2270c;
    box-shadow: 0 3px 6px 0 rgba(242, 39, 12, .1);
}

.ds-button-large {
    margin: 0 $pageSpace;
}

.popup-box {
    .popup-img {
        width: 100%;
        height: 100%;
    }
}

::v-deep .mint-popup {
    background: transparent;
}
</style>
